import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  private currencyMap: Record<string, string> = {
    USD: '$',
    INR: '₹',
    EUR: '€',
    GBP: '£',
    AED: 'د.إ',
    AUD: '$',
    CAD: '$',
    SGD: '$',
    JPY: '¥',
    CNY: '¥',
    BRL: 'R$',
    MXN: '$',
    ZAR: 'R',
    KRW: '₩',
    THB: '฿',
    MYR: 'RM',
    PHP: '₱',
    IDR: 'Rp',
    VND: '₫',
    NZD: '$',
    HKD: '$',
    TWD: 'NT$',
    SEK: 'kr',
    NOK: 'kr',
    CHF: 'CHF',
    RUB: '₽',
    TRY: '₺',
    SAR: 'ر.س',
    QAR: 'ر.ق',
    KWD: 'د.ك',
    BHD: '.د.ب',
    OMR: 'ر.ع.',
    ARS: '$',
    CLP: '$',
    COP: '$',
    PEN: 'S/'
  };

  transform(code: string | null | undefined): string {

    if (!code) return '--';

    return this.currencyMap[code] || code;
  }
}